import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import ArticleHero from "../components/ArticleHero";
import articlesData from "../data/articlesData";
import "../styles/ArticlePage.css";

const ArticlePage = () => {
  const { articleId } = useParams();
  const { language } = useLanguage();
  const article = articlesData[language][articleId];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!article) {
    return <h2>Artículo no encontrado</h2>;
  }

  return (
    <div className="article-page">
      <ArticleHero
        title={article.title}
        description={article.description}
        backgroundImage={article.image}
      />
      <div
        className="article-content"
        dangerouslySetInnerHTML={{ __html: article.content }}
      />
    </div>
  );
};

export default ArticlePage;
